import { useMemo } from 'react';
import type { ChamadoKanban } from '../types/api';
import { 
  groupChamadosByStatus, 
  getStatusConfig, 
  calculateChamadosStats 
} from '../utils/chamadoUtils';

/**
 * Hook para processar dados do kanban com memoization
 */
export const useKanbanData = (chamados: ChamadoKanban[]) => {
  return useMemo(() => {
    const chamadosPorStatus = groupChamadosByStatus(chamados);
    const statusConfig = getStatusConfig();
    const stats = calculateChamadosStats(chamados);

    return {
      chamadosPorStatus,
      statusConfig,
      stats,
      isEmpty: chamados.length === 0
    };
  }, [chamados]);
};